module.exports = __webpack_public_path__ + "img/link2.4fb1d427.png";